import { Instagram, Facebook, Linkedin, Youtube, Music2, Twitter } from "lucide-react";

/**
 * Platform key (lib/siteLinks.js `SOCIAL_PLATFORMS`) -> icon component.
 *
 * Kept OUT of siteLinks.js so that the link model stays a pure data module with no UI
 * dependency, and out of the six footers so that adding a network is one edit rather than
 * seven. Each theme still sizes and styles the icon itself — this map only answers "which
 * glyph", never "how big" or "what colour".
 *
 * `Music2` stands in for TikTok and `Twitter` for X: lucide-react (0.516) ships no glyph
 * for either brand, and a missing component would render nothing at all.
 */
export const SOCIAL_ICONS = {
  instagram: Instagram,
  facebook: Facebook,
  linkedin: Linkedin,
  youtube: Youtube,
  tiktok: Music2,
  x: Twitter,
};

export default SOCIAL_ICONS;
